import { api } from 'api';

export const login = () => {
  return api.get$('home');
};

export const getInfo = () => {
  return api.get$('api/userinfo');
};
